export const IMAGE_POPUP_OPEN = 'IMAGE_POPUP_OPEN'
export const IMAGE_POPUP_CLOSE = 'IMAGE_POPUP_CLOSE'


// WEBPACK FOOTER //
// ./src/constants/index.js